<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!-- 风控选项 -->
      <div class="common-form">风控开关</div>
      <el-form-item label="百融">
        <el-radio-group v-model="form.br_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="布尔">
        <el-radio-group v-model="form.bl_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="掌签征信">
        <el-radio-group v-model="form.zq_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="浩程达">
        <el-radio-group v-model="form.zx_info_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="租先知">
        <el-radio-group v-model="form.zxz_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="新颜">
        <el-radio-group v-model="form.xy_status">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="流水报告">
        <el-radio-group v-model="form.ls_report">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="法谡">
        <el-radio-group v-model="form.tempVal">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 客服信息 -->
      <div class="common-form">功能配置</div>
      <el-form-item label="客服电话" prop="cyphone">
        <el-input v-model="form.cyphone" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="租户ID" prop="tenant_id">
        <el-input v-model="form.tenant_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="聊天框ID" prop="chat_wd_id">
        <el-input v-model="form.chat_wd_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="水印内容" prop="chat_wd_id">
        <!-- <el-input @blur="inputWatermark(watermarkContent)" v-model="watermarkContent" class="max-w460"></el-input> -->
        <el-input v-model="form.watermark" @blur="inputWatermark(form.watermark)" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="水印">
        <!-- @change="watermarkClick" -->
        <el-radio-group v-model="form.is_watermark" @change="watermarkClick">
          <el-radio label="1">开启水印</el-radio>
          <el-radio label="0">关闭水印</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="以租代购">
        <el-radio-group v-model="form.car_lease">
          <el-radio label="1">开启</el-radio>
          <el-radio label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预授权" prop="dp_status">
        <el-switch v-model="form.dp_status" type="primary" active-value="1" inactive-value="0">
        </el-switch>
      </el-form-item>
      <el-form-item label="商家主动还款是否扣除余额">
        <el-switch v-model="form.active_repayment_dec" type="primary" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
      <el-form-item label="验收退款按钮" >
        <el-switch active-color="#13ce66" v-model="form.mianyaRefund" :inactive-value="0"
          :active-value="1"></el-switch>
      </el-form-item>
      <!-- 赋强公证信息 -->
      <div class="common-form">赋强公证法人及公司信息</div>
      <el-form-item label="公司名称" prop="Applicant_Name">
        <el-input v-model="form.Applicant_Name" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="法人姓名" prop="Legal_Name" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Legal_Name" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="统一社会信用代码" prop="Uniform_Credit_Code" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Uniform_Credit_Code" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="公司名称" prop="sex" :rules="[{ required: true, message: '' }]">
        <el-select v-model="form.sex" placeholder="请选择性别">
          <el-option label="男" value="1"> </el-option>
          <el-option label="女" value="0"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="法人生日" prop="Birthdate" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Birthdate" class="max-w460"></el-input>
        <div class="tips">例:1990-07-28</div>
      </el-form-item>

      <el-form-item label="法人身份证号" prop="Id_Number" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Id_Number" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="手机号" prop="Phone" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Phone" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="公司地址" prop="Address" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Address" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="Email" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.Email" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="身份证正面" :rules="[{ required: true, message: '请上传身份证正面!' }]">
        <el-upload class="avatar-uploader" action="/index.php/shop/gongzheng1.index/UploadFile" name="iFile"
          :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="form.sfzzm_url" :src="form.sfzzm_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="身份证反面" :rules="[{ required: true, message: '请上传身份证反面!' }]">
        <el-upload class="avatar-uploader" action="/index.php/shop/gongzheng1.index/UploadFile" name="iFile"
          :show-file-list="false" :on-success="handleAvatarSuccess2">
          <img v-if="form.sfzfm_url" :src="form.sfzfm_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="营业执照" :rules="[{ required: true, message: '请上传营业执照!' }]">
        <el-upload class="avatar-uploader" action="/index.php/shop/gongzheng1.index/UploadFile" name="iFile"
          :show-file-list="false" :on-success="handleAvatarSuccess3">
          <img v-if="form.yyzz_url" :src="form.yyzz_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <el-form-item label="法定代表人证明" :rules="[{ required: true, message: '法定代表人证明!' }]">
        <el-upload class="avatar-uploader" action="/index.php/shop/gongzheng1.index/UploadFile" name="iFile"
          :show-file-list="false" :on-success="handleAvatarSuccess4">
          <img v-if="form.fddbrzm_url" :src="form.fddbrzm_url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>

      <!--苹果审核-->
      <!-- <div class="common-form">苹果审核</div>
      <el-form-item label="用户提交的个人信息" prop="apptExamine">
        <el-radio v-model="form.apptExamine" label="0">显示</el-radio>
        <el-radio v-model="form.apptExamine" label="1">隐藏</el-radio>
      </el-form-item> -->

      <div class="common-form">验证</div>
      <el-form-item label="下单信息验证" prop="orderPersonalInformation">
        <el-radio v-model="form.orderPersonalInformation" label="0">显示</el-radio>
        <el-radio v-model="form.orderPersonalInformation" label="1">隐藏</el-radio>
      </el-form-item>

      <!--添加门店-->
      <div class="common-form">控制小程序</div>
      <el-form-item label="控制租完即送" prop="ddshow">
        <el-radio v-model="form.ddshow" label="0">显示</el-radio>
        <el-radio v-model="form.ddshow" label="1">隐藏</el-radio>
      </el-form-item>
      <el-form-item label="控制手机详情页介绍" prop="zmshow">
        <el-radio v-model="form.zmshow" label="1">显示</el-radio>
        <el-radio v-model="form.zmshow" label="0">隐藏</el-radio>
      </el-form-item>
      <el-form-item label="租赁动态" prop="trends" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.trends" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="AppID" prop="app_id" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.app_id" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">会员卡</div>
      <el-form-item label="会员卡号" prop="template_id" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.template_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商城操作密码" prop="shop_password" :rules="[{ required: true, message: '' }]">
        <el-input v-model="form.shop_password" class="max-w460"></el-input>
      </el-form-item>

      <!-- <div style="margin: 10px;">
        <el-link type="danger">会员卡号: {{ form.template_id }} </el-link> <br />
        <div style="height: 50px;line-height: 50px;">
          <el-link icon="el-icon-edit" @click="xiugai" v-if="form.template_id">修改</el-link>
          <el-link icon="el-icon-edit" @click="huiyuan" v-else>创建</el-link>
          <el-link icon="el-icon-s-tools" @click="kaika" style="margin-left:10px;">开卡</el-link>
        </div>
      </div> -->

      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{ required: true, message: ' ' }]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.checkedCities">
          <el-checkbox v-for="(item, index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <div class="tips">注：配送方式至少选择一个</div>
      </el-form-item>
      <el-form-item label="是否显示店铺信息">
        <div>
          <el-radio v-model="form.store_open" label="1">显示</el-radio>
          <el-radio v-model="form.store_open" label="0">关闭</el-radio>
        </div>
        <div class="tips">主要用于微信小程序过审隐藏</div>
      </el-form-item>
      <el-form-item label="LOGO" :rules="[{ required: true, message: '请输入LOGO图片' }]">
        <el-button @click="chooseImg('logo1', 'logo')">选择图片</el-button>
        <img class="mt10" v-img-url="form.logo" width="200" />
        <el-button type="primary" @click="onSubmit1" style="margin: 10px">上传素材提交</el-button>
      </el-form-item>
      <el-form-item label="背景图片" :rules="[{ required: true, message: '请输入背景图片' }]">
        <el-button @click="chooseImg('background', 'background')">选择图片</el-button>
        <img class="mt10" v-img-url="form.background" width="200" />
        <el-button type="primary" @click="onSubmit2" style="margin: 10px">上传素材提交</el-button>
      </el-form-item>

      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.is_get_log">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递100 Customer" :rules="[{ required: true, message: ' ' }]" prop="customer">
        <el-input v-model="form.customer" placeholder="" class="max-w460"></el-input>
        <div class="tips">
          用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
            type="primary">快递100申请</el-link>
        </div>
      </el-form-item>
      <el-form-item label="快递100 Key" :rules="[{ required: true, message: ' ' }]" prop="key">
        <el-input v-model="form.key" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">商户入驻设置</div>
      <el-form-item label="是否开启短信验证">
        <div>
          <el-radio v-model="form.sms_open" label="1">开启</el-radio>
          <el-radio v-model="form.sms_open" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <div class="common-form">平台运营设置</div>
      <el-form-item label="抽成百分比(%)" :rules="[{ required: true, message: ' ' }]" prop="commission_rate">
        <el-input v-model="form.commission_rate" placeholder="抽查比例" class="max-w460" type="number"
          @keyup.native="renumber($event)"></el-input>
      </el-form-item>
      <el-form-item label="平台运营商配置">
        <div>
          <el-radio v-model="form.platformOperation" label="1">总后台</el-radio>
          <el-radio v-model="form.platformOperation" label="2">商户</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品新增是否审核">
        <div>
          <el-radio v-model="form.add_audit" label="1">是</el-radio>
          <el-radio v-model="form.add_audit" label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品修改是否审核">
        <div>
          <el-radio v-model="form.edit_audit" label="1">是</el-radio>
          <el-radio v-model="form.edit_audit" label="0">否</el-radio>
        </div>
      </el-form-item>
      <div class="common-form">商户图片背景</div>
      <el-form-item label="商户入住背景" :rules="[{ required: true, message: '请输入商户入住图片' }]">
        <el-button @click="chooseImg('image', 'supplier_image')">选择图片</el-button>
        <img class="mt10" v-img-url="form.supplier_image" width="200" />
      </el-form-item>
      <div class="common-form">政策协议</div>
      <el-form-item label="服务协议" :rules="[{ required: true, message: ' ' }]" prop="service">
        <el-input v-model="form.service" placeholder="" class="max-w460"></el-input>
        <div class="tips"><el-link>进入app和登录、注册页面显示</el-link></div>
      </el-form-item>
      <el-form-item label="隐私政策" :rules="[{ required: true, message: ' ' }]" prop="privacy">
        <el-input v-model="form.privacy" placeholder="" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">费用信息(元)</div>
      <el-form-item label="百融风控" :rules="[{ required: true, message: ' ' }]" prop="bairong">
        <el-input v-model="form.bairong" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="云信上报" :rules="[{ required: true, message: ' ' }]" prop="yxshangbao">
        <el-input v-model="form.yxshangbao" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="人脸识别" :rules="[{ required: true, message: ' ' }]" prop="renlian">
        <el-input v-model="form.renlian" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="电子签章" :rules="[{ required: true, message: ' ' }]" prop="qianzhang">
        <el-input v-model="form.qianzhang" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="三要素" :rules="[{ required: true, message: ' ' }]" prop="sanyaosu">
        <el-input v-model="form.sanyaosu" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="电子签章存证证明" :rules="[{ required: true, message: ' ' }]" prop="cunzhengzhewngming">
        <el-input v-model="form.cunzhengzhewngming" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="快递查询" :rules="[{ required: true, message: ' ' }]" prop="kuaidi">
        <el-input v-model="form.kuaidi" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="短信" :rules="[{ required: true, message: ' ' }]" prop="duanxin">
        <el-input v-model="form.duanxin" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证ORC" :rules="[{ required: true, message: ' ' }]" prop="ORC">
        <el-input v-model="form.ORC" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="蚁盾" :rules="[{ required: true, message: ' ' }]" prop="yidun">
        <el-input v-model="form.yidun" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="实名认证" :rules="[{ required: true, message: ' ' }]" prop="shiming">
        <el-input v-model="form.shiming" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="电子合同" :rules="[{ required: true, message: ' ' }]" prop="hetong">
        <el-input v-model="form.hetong" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="区块链保险长租" :rules="[{ required: true, message: ' ' }]" prop="qukuailianbaoxiancz">
        <el-input v-model="form.qukuailianbaoxiancz" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="区块链保险短租" :rules="[{ required: true, message: ' ' }]" prop="qukuailianbaoxiandz">
        <el-input v-model="form.qukuailianbaoxiandz" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="天狼星" :rules="[{ required: true, message: ' ' }]" prop="tianlangxin">
        <el-input v-model="form.tianlangxin" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="逾期报告" :rules="[{ required: true, message: ' ' }]" prop="yuqibaogao">
        <el-input v-model="form.yuqibaogao" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="贷款报告" :rules="[{ required: true, message: ' ' }]" prop="daikuanbaogao">
        <el-input v-model="form.daikuanbaogao" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="风险查询" :rules="[{ required: true, message: ' ' }]" prop="fengxin">
        <el-input v-model="form.fengxin" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="征信报告" :rules="[{ required: true, message: ' ' }]" prop="zhengxin">
        <el-input v-model="form.zhengxin" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="分销百分比" :rules="[{ required: true, message: ' ' }]" prop="fengxiao">
        <el-input v-model="form.fengxiao" placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="分销金额" :rules="[{ required: true, message: ' ' }]" prop="retailStore">
        <el-input v-model="form.retailStore" placeholder="" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">新颜报价金额</div>
      <el-form-item v-for="(item, index) in typeOptions" :label="item.label" :prop="item.value" :key="index">
        <el-input v-model="form[item.value]" placeholder="" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import Upload from "@/components/file/Upload";
import { formatModel } from "@/utils/base.js";

const funcConfig = {
  /*功能配置*/
  cyphone: "", // 客服电话
  tenant_id: '',
  chat_wd_id: '',
  dp_status: "0", // 预授权 开启后跳过订单流程？
  car_lease: "", // 以租代购
  active_repayment_dec:0,
  mianyaRefund:0
}

const riskControl = {
  /*风控开关*/
  br_status: "", // 百融
  bl_status: "", // 布尔
  zq_status: "", // 掌签
  zx_info_status: "", // 征信详情版本
  zxz_status: "", // 租先知
  xy_status: "",// 新颜
  ls_report: '' //流水
}

const typeOptions = [
  /*新颜报价*/
  { label: 'L', value: 'L' },
  { label: 'M', value: 'M' },
  { label: 'H', value: 'H' },
  { label: 'Hv2', value: 'Hv2' },
  { label: 'Hv3', value: 'Hv3' },
  { label: "雷达", value: "radar" },
  { label: "当前逾期", value: "tanza" },
  { label: "云黑名单", value: "zblacklist" },
  { label: "三要素验证", value: "trueman" },
  { label: "基础状态", value: "basestatus" },
  { label: "个人涉诉", value: "plinfp" },
  { label: "高风险核查", value: "highrisk" },
  { label: "借贷履约记录", value: "snxyp" },
  { label: "偿债压力", value: "debtstress" },
  { label: "团伙欺诈排查", value: "fraudgrop" },
  { label: "3C租聘申请记录", value: "apply3c" },
  { label: "特殊名单验证", value: "speclist" },
  { label: "法院限高被执行人", value: "execlimit" }
];

const xyQuotation = typeOptions.reduce((pre, key) => {
  pre[key.value] = "";
  return pre;
}, {});


export default {
  components: {
    Upload
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      typeOptions,
      /*form表单数据*/
      form: {
        name: "",
        customer: "",
        key: "",
        supplier_cash: "",
        operate_type: "",
        commission_rate: "",
        platformOperation: 1,
        supplier_image: "",
        sms_open: "",
        supplier_logo: "",
        checkedCities: [],
        edit_audit: 1,
        add_audit: 1,
        is_get_log: 0,
        service: "",
        privacy: "",
        store_open: "",
        ddshow: "",
        apptExamine: "",
        zmshow: "",
        trends: "",
        bairong: "",
        yxshangbao: "",
        renlian: "",
        qianzhang: "",
        sanyaosu: "",
        cunzhengzhewngming: "",
        kuaidi: "",
        duanxin: "",
        ORC: "",
        yidun: "",
        shiming: "",
        hetong: "",
        qukuailianbaoxiancz: "",
        qukuailianbaoxiandz: "",
        tianlangxin: "",
        yuqibaogao: "",
        daikuanbaogao: "",
        fengxin: "",
        zhengxin: "",
        fengxiao: "",
        background: "",
        logo: "",
        retailStore: "",
        template_id: "",
        shop_password: "",
        app_id: "",
        orderPersonalInformation: "",
        Applicant_Name: "",
        Legal_Name: "",
        Uniform_Credit_Code: "",
        sex: "",
        Birthdate: "",
        Id_Number: "",
        Phone: "",
        Address: "",
        Email: "",
        sfzzm_name: "",
        sfzzm_url: "",
        sfzfm_name: "",
        sfzfm_url: "",
        yyzz_name: "",
        yyzz_url: "",
        fddbrzm_name: "",
        fddbrzm_url: "",
        watermark: "", //水印内容
        is_watermark: "", //水印开关 0：关闭，1：开启

        ...funcConfig,
        ...riskControl,
        ...xyQuotation,
        tempVal: '',
      },
      all_type: [],
      type: [],
      /*是否打开图片选择*/
      isupload: false,
      // 水印
      watermarkContent: this.$store.state.user.watermarkContent, // 水印内容
      watermark: this.$store.state.user.watermark, // 水印  1开启水印 2关闭水印
    };
  },
  created() {
    this.getParams();
  },

  methods: {
    // 水印是否展示
    watermarkClick(e) {
      console.log(e, '水印')
      localStorage.setItem('watermark', JSON.stringify(e))
      this.$store.commit("user/convert", JSON.stringify(e));
    },
    // 修改水印内容
    inputWatermark(e) {
      console.log(e, '水印内容')
      localStorage.setItem('watermarkContent', JSON.stringify(e))
      this.$store.commit("user/convertContent", JSON.stringify(e));
    },
    // 成功上传
    handleAvatarSuccess(res, file) {
      // this.form.sfzzm_url = URL.createObjectURL(file.raw);
      this.form.sfzzm_url = res.data.data.file_Url;
      this.form.sfzzm_name = res.data.data.file_Name;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess2(res, file) {
      // this.form.sfzfm_url = URL.createObjectURL(file.raw);
      this.form.sfzfm_url = res.data.data.file_Url;
      this.form.sfzfm_name = res.data.data.file_Name;
    },
    handleAvatarSuccess3(res, file) {
      // this.form.yyzz_url = URL.createObjectURL(file.raw);
      this.form.yyzz_url = res.data.data.file_Url;
      this.form.yyzz_name = res.data.data.file_Name;
    },
    handleAvatarSuccess4(res, file) {
      // this.form.fddbrzm_url = URL.createObjectURL(file.raw);
      this.form.fddbrzm_url = res.data.data.file_Url;
      this.form.fddbrzm_name = res.data.data.file_Name;
    },
    //会员开卡
    kaika() {
      this.$confirm("确定要进行开卡操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let self = this;
          let tmpid = self.form.template_id;
          SettingApi.kaika({ tmpid: tmpid }, true)
            .then(data => {
              console.log(data);
              self.loading = false;
              if ((data.data.res.msg = "Success")) {
                self.$message({
                  message: "开卡成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //修改会员
    xiugai() {
      this.$confirm("确定要进行修改会员操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let self = this;
          let tmpid = self.form.template_id;
          SettingApi.templateModify({ tmpid: tmpid }, true)
            .then(data => {
              console.log(data);
              self.loading = false;
              if ((data.data.res.msg = "Success")) {
                self.$message({
                  message: "修改成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //创建会员
    huiyuan() {
      this.$confirm("确定要进行创建会员操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info "
      })
        .then(() => {
          let self = this;
          SettingApi.createCard({}, true)
            .then(data => {
              self.loading = false;
              if ((data.data.res.msg = "Success")) {
                self.form.template_id = data.data.res.template_id;
                self.onSubmit();
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.storeDetail({}, true)
        .then(res => {
          let vars = res.data.vars.values;
          self.form = formatModel(self.form, vars);
          console.log(vars);
          localStorage.setItem('watermarkContent', JSON.stringify(vars.watermark))
          this.$store.commit("user/convertContent", JSON.stringify(vars.watermark));
          localStorage.setItem('watermark', JSON.stringify(vars.is_watermark))
          this.$store.commit("user/convert", JSON.stringify(vars.is_watermark));
          self.form.checkedCities = res.data.vars.values.delivery_type;
          // 转成整数，兼容组件
          for (let i = 0; i < self.form.checkedCities.length; i++) {
            self.$set(
              self.form.checkedCities,
              i,
              parseInt(self.form.checkedCities[i])
            );
          }
          self.all_type = res.data.all_type;
          self.type = vars.delivery_type;
          self.form.customer = vars.kuaidi100.customer;
          self.form.key = vars.kuaidi100.key;
          self.form.service = vars.policy.service;
          self.form.privacy = vars.policy.privacy;
          self.form.trends = vars.trends;
          self.bairong = vars.bairong;
          self.yxshangbao = vars.yxshangbao;
          self.sanyaosu = vars.sanyaosu;
          self.cunzhengzhewngming = vars.cunzhengzhewngming;
          self.kuaidi = vars.kuaidi;
          self.duanxin = vars.duanxin;
          self.ORC = vars.ORC;
          self.yidun = vars.yidun;
          self.shiming = vars.shiming;
          self.hetong = vars.hetong;
          self.form.active_repayment_dec = Number(vars.active_repayment_dec);
          self.form.mianyaRefund = Number(vars.mianyaRefund);
          self.qukuailianbaoxiancz = vars.qukuailianbaoxiancz;
          self.qukuailianbaoxiandz = vars.qukuailianbaoxiandz;
          self.tianlangxin = vars.tianlangxin;
          self.yuqibaogao = vars.yuqibaogao;
          self.daikuanbaogao = vars.daikuanbaogao;
          self.fengxin = vars.fengxin;
          self.zhengxin = vars.zhengxin;
          self.fengxiao = vars.fengxiao;
          self.retailStore = vars.retailStore;
          self.logo = vars.logo;
          self.background = vars.background;
          self.template_id = vars.template_id;
          self.app_id = vars.app_id;
          self.loading = false;
        })
        .catch(error => { });
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
      if (params.checkedCities.length < 1) {
        self.$message({
          message: "配送方式至少选择一种！",
          type: "warning"
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "恭喜你，商城设置成功",
                type: "success"
              });
              self.$router.push("/setting/store/index");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    // 上传素材
    onSubmit1() {
      let self = this;
      SettingApi.uploadimage({ type: "logo_id", filename: self.logo }, true)
        .then(data => {
          self.$message({
            message: "操作成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    onSubmit2() {
      let self = this;
      SettingApi.uploadimage(
        { type: "background_id", filename: self.background },
        true
      )
        .then(data => {
          self.$message({
            message: "操作成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    renumber(e) {
      var keynum = window.event ? e.keyCode : e.which;
      var keycar = String.fromCharCode(keynum);
      if (keynum == 189 || keynum == 190 || keynum == 110 || keynum == 109) {
        this.$message.warning("禁止输入小数和负数");
        e.target.value = "";
      }
    },
    /*选择图片*/
    chooseImg(file_type, file_name) {
      this.file_name = file_name;
      this.isupload = true;
      this.type = file_type;
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      if (e != null && e.length > 0) {
        if (this.type == "logo") {
          this.form.supplier_logo = e[0].file_path;
        } else if (this.type == "image") {
          this.form.supplier_image = e[0].file_path;
        } else if (this.type == "logo1") {
          this.form.logo = e[0].file_path;
        } else if (this.type == "background") {
          this.form.background = e[0].file_path;
        }
      }
    }
  }
};
</script>
<style>
.tips {
  color: #ccc;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue